<template>
  <div class="body rtls">
    <div class="login-container p-3 px-5 text-center bg-white mt-0 ">
      <img
        src="img/logo.png"
        alt="جت بار"
        style="width: 250px"
        class="m-auto d-block text-center"
      />
      <form class="mt-4" role="form">
        <div :class="`form-group ${hasError ? 'has-error' : ''}`">
          <input
            type="email"
            class="form-control on-active"
            placeholder="شماره‌موبایل یا نام‌کاربری"
            required="true"
            v-model="login.username"
          />
        </div>
        <div :class="`form-group ${hasError ? 'has-error' : ''}`">
          <input
            type="password"
            class="form-control on-active"
            placeholder="کلمه‌عبور"
            required="true"
            v-model="login.password"
          />
        </div>
        <h3 v-if="hasError" class="text-danger">
          {{ errorMessage }}
        </h3>
        <button
          @click="logUserIn"
          type="submit"
          class="btn btn-success block full-width m-b mt-4"
        >
          ورود
        </button>
        <p class="m-t">
          <small style="font-size: 11px"
            >تمام حقوق و امتیاز سایت متعلق به جت بار می باشد .</small
          >
        </p>
      </form>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      login: {
        username: "",
        password: "",
      },
      hasError: false,
      errorMessage: "",
    };
  },
  mounted() {
    this.$setLayout("simple-layout");
  },
  methods: {
    logUserIn(e) {
      e.preventDefault();
      if (!this.login.username || !this.login.password) {
        this.hasError = true;
        this.errorMessage = "اطلاعات کامل وارد نشده است";
        return;
      }
      this.$setIsLoading(true);
      var vm = this;
      this.$persistClient("post", "/login", this.login)
        .then((res) => {
          if (res && res.data) {
            this.$store.dispatch("login", res.data);
          this.$router.push("/");
        
          }
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.hasError = true;
            this.errorMessage = " اطلاعات ورود نادرست است";
          }
        })
        .finally(() => {
          setTimeout(() => {
            vm.$setIsLoading(false);
          }, 500);
        });
    },
  },
};
</script>
<style scoped>
.logo-name {
  color: #e6e6e6 !important;
  font-size: 68px !important;
  font-weight: 800 !important;
  letter-spacing: -5px !important;
  margin-bottom: 0 !important;
}
.middle-box {
  max-width: 400px;
  z-index: 100;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-203px, -200px);
}
.loginscreen.middle-box {
  background: #fff;
  margin: auto;
}
input {
  text-align: center;
  height: 39px;
  border-radius: 5px;
}
.login-container button {
  background: #14a9d9 !important;
  border: #1a8cb3;
}
.body.rtls {
  height: 100%;
  width: 100%;
  background: url(../assets/img/background.jpg);
  background-size: cover;
  background-repeat: no-repeat;
}
a.btn.btn-primary.block.full-width.m-b {
  height: 39px;
  line-height: 27px;
  color: #fff;
}
input.on-active {
  transition-duration: 500ms;
  transition-property: all;
  transition-timing-function: ease-in-out;
  font-size: 14px !important;
}
input.on-active:focus {
  background: #c5c5c5 !important;
  transform: scale(1.02);
  border: 2px solid #ccc;
}
.body.rtls {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
